import React from "react";
import { Box, Typography } from "@mui/material";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const MenuCard = () => {
  const version = "1.0.0";

  return (
    <Box
      sx={{
        mt: 0.75,
        mb: 0.5,
        px: 1.25,
        py: 1,

        display: "flex",
        alignItems: "center",

        borderRadius: "8px",

        backgroundColor: "rgba(255,255,255,0.08)",

        border: "1px solid rgba(255,255,255,0.08)",

        color: "#fff",
      }}
    >
      {/* =====================================================
          ICON
      ===================================================== */}

      <Box
        sx={{
          width: 32,
          height: 32,

          flexShrink: 0,

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          borderRadius: "7px",

          backgroundColor: "rgba(255,255,255,0.95)",

          color: "#123B5D",

          mr: 1.25,
        }}
      >
        <InfoOutlinedIcon
          sx={{
            fontSize: 18,
          }}
        />
      </Box>

      {/* =====================================================
          VERSION TEXT
      ===================================================== */}

      <Box
        sx={{
          minWidth: 0,
        }}
      >
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: 1.3,

            color: "rgba(255,255,255,0.75)",
          }}
        >
          Version
        </Typography>

        <Typography
          sx={{
            mt: 0.25,

            fontSize: "11px",
            fontWeight: 600,
            lineHeight: 1.3,

            color: "#fff",
          }}
        >
          {version}
        </Typography>
      </Box>
    </Box>
  );
};

export default MenuCard;
